export enum UnitType {
  Apartment = 'apartment',
  OfficeSpace = 'OfficeSpace',
}

export default UnitType;
